// The one-tap stay presets, shared by the plan chips and the section card so
// the same chip lights up everywhere. No chip selected = no stay entered, and
// the map shows free/paid at the chosen moment instead of prices.

export const STAYS = [
  { key: 'preset30', value: () => '30 min' },
  { key: 'preset1h', value: () => '1 h' },
  { key: 'preset2h', value: () => '2 h' },
  { key: 'preset3h', value: () => '3 h' },
  { key: 'presetNight', value: (lang) => (lang === 'en' ? 'overnight' : 'přes noc') },
]

/** Does the typed duration text match a preset value? */
export function matchesStay(text, value) {
  return String(text).trim().toLowerCase() === value.toLowerCase()
}

const steps = (from, to, by) => Array.from({ length: (to - from) / by + 1 }, (_, i) => from + i * by)

/**
 * The stay slider's stops, in minutes; 0 = no stay. Five-minute steps through
 * the first hour, where they matter, then coarser up to a whole day — so a
 * thumb can still land on "1 h 15 min".
 */
export const STAY_STOPS = [0, ...steps(5, 60, 5), ...steps(75, 240, 15), ...steps(270, 720, 30), ...steps(780, 1440, 60)]

/** The stop nearest to a stay (an overnight stay rarely lands on one). */
export function stopIndex(minutes) {
  let best = 0
  STAY_STOPS.forEach((s, i) => {
    if (Math.abs(s - minutes) < Math.abs(STAY_STOPS[best] - minutes)) best = i
  })
  return best
}

/** A slider stop as stay text, in the presets' own words ("1 h", "30 min") so their chips light up. */
export function stayText(minutes) {
  if (!minutes) return ''
  return minutes % 60 === 0 ? `${minutes / 60} h` : `${minutes} min`
}
